theme.TimelineAnimation = (function () {
  function TimelineAnimation(container) {
    this.container = container;
    this.init();
  }

  function getIsDesktop() {
    return window.matchMedia('(min-width: 1024px)').matches;
  }

  function initMobileSwiper(container) {
    const isDesktop = getIsDesktop();

    let swiperInstance;
    let currentMode = null;
    const swiperEl = container.querySelector('.swiper.swiper__first-section');
    if (!swiperEl) return;
    if (isDesktop) {
      // Destroy previous instance if it exists
      swiperInstance?.destroy();
    } else {
      if (swiperInstance?.mounted) return;

      swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        slidesOffsetAfter: 20,
        slidesOffsetBefore: 20,
        grabCursor: true,
        spaceBetween: 10,
        breakpoints: {
          768: {
            spaceBetween: 20,
            centeredSlides: true,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
          },
        },
      });
    }
    currentMode = isDesktop;
  }

  function initMobileSwiperTwo(container) {
    const isDesktop = getIsDesktop();

    let swiperInstance;
    let currentMode = null;
    let previousIndex = 0;
    const swiperEl = container.querySelector('.swiper.swiper__second-section');
    if (!swiperEl) return;
    if (isDesktop) {
      // Destroy previous instance if it exists
      swiperInstance?.destroy();
    } else {
      if (swiperInstance?.mounted) return;
      const progressContent = container.querySelectorAll(
        '.timeline-progress__content',
      );

      const progressWrapper = container.querySelector(
        '.timeline-progress__wrapper',
      );

      const xTranslation = progressWrapper.getBoundingClientRect().width / 2;
      swiperInstance = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        slidesOffsetAfter: 20,
        slidesOffsetBefore: 20,
        spaceBetween: 10,
        grabCursor: true,
        breakpoints: {
          768: {
            spaceBetween: 20,
            centeredSlides: true,
            slidesOffsetAfter: 0,
            slidesOffsetBefore: 0,
          },
        },
        on: {
          init(swiper) {
            previousIndex = swiper.realIndex;
          },
          slideChange(swiper) {
            const currentIndex = swiper.realIndex;
            const isForward = currentIndex > previousIndex;
            const transitionForward =
              'transform 500ms ease-in-out, opacity 0ms ease-in-out 500ms';

            const transitionBackward =
              'transform 500ms ease-in-out, opacity 0ms ease-in-out';

            const transition = isForward ? transitionForward : transitionBackward;
            progressContent.forEach((content, i) => {
              const point = content.querySelector('.timeline-progress__points');
              const copy = content.querySelector('.timeline-progress__copy');
              const svgBubble = content.querySelector('.timeline__text-bubble');

              point.style.transition = transition;
              point.style.opacity = i < currentIndex ? 0 : 1;
              point.style.transform = `translateX(${-1 * (xTranslation * currentIndex)}px) scale(${i < currentIndex ? 0.5 : 1})`;
              copy.style.opacity = i === currentIndex ? 1 : 0;
              svgBubble.style.opacity = i === currentIndex ? 1 : 0;
              copy.classList.toggle('fade-out-background', i === currentIndex);
            });

            previousIndex = currentIndex;
          },
        },
      });
    }
    currentMode = isDesktop;
  }

  TimelineAnimation.prototype.init = function () {
    initMobileSwiper(this.container);
    initMobileSwiperTwo(this.container);
    const containerTrigger = this.container.querySelector('.timeline__wrapper');
    const progressContent = this.container.querySelectorAll(
      '.timeline-progress__content',
    );
    const progressPointDescriptions = this.container.querySelectorAll(
      '.timeline-progress__copy',
    );
    const slides = this.container.querySelectorAll('.timeline__slide');

    if (
      !containerTrigger ||
      !progressContent ||
      !progressPointDescriptions ||
      !slides.length
    )
      return;

    const contentScrollFactor = 800;
    const contentCount = progressContent.length - 2; // exclude first
    const totalContentScroll = contentCount * contentScrollFactor;

    const defaultColor = '#FCF6E8';
    const activeColor = '#3F0022';

    const mm = gsap.matchMedia();

    mm.add({ isDesktop: '(min-width: 1024px)' }, (context) => {
      const { isDesktop } = context.conditions;

      if (isDesktop) {
        let prevIndex = 0;
        let offset =
          progressContent[1].getBoundingClientRect().top -
          progressContent[1].parentNode.getBoundingClientRect().top;
        const firstPart = offset * 0.8;
        const lastPart = offset * 0.2;
        const parent = progressContent[1].parentNode;
        const parentStyles = window.getComputedStyle(parent);
        const marginTop = parentStyles.marginTop.slice(0,-2); // remove 'px'
        const steadyMovement = marginTop / (progressContent.length - 1); // dynamic steady movement based on vh?

        gsap.set(slides, {
          opacity: (index) => (index === 0 ? 1 : 0),
        });
        gsap.set(progressPointDescriptions, {
          color: (index) => (index === 0 ? activeColor : defaultColor),
        });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: containerTrigger,
            start: 'top top',
            end: `+=${totalContentScroll}`,
            scrub: true,
            pin: true,
            // markers: true,
          },
        });
        // console.log(offset, firstPart, lastPart);
        progressContent.forEach((content, i) => {
          if (i > 1) offset = offset - 50; // TODO: update
          if (i > 0) {
            const prevSvgs = progressContent[prevIndex].querySelectorAll(
              '.timeline__text-bubble',
            );
            const svgs = content.querySelectorAll('.timeline__text-bubble');

            tl.to(content, {
              y: `-=${firstPart}`,
              ease: 'none',
            });

            progressContent.forEach((c, j) => {
              if (j !== i) {
                tl.to(
                  c,
                  {
                    y: `-=${steadyMovement / 2}`,
                    ease: 'none',
                  },
                  '<',
                );
              }
            });

            tl.to(
              svgs,
              {
                opacity: 1,
                duration: 0.001,
                ease: 'power1.inOut',
              },
              '>',
            );
            tl.to(
              progressPointDescriptions[prevIndex],
              {
                background: 'transparent',
                duration: 0.001,
                ease: 'power1.inOut',
              },
              '<',
            );
            tl.to(
              prevSvgs,
              {
                opacity: 0,
                duration: 0.001,
                ease: 'power1.inOut',
              },
              '<',
            );
            tl.to(
              progressPointDescriptions[i],
              {
                background: '#ff64c3',
                duration: 0.001,
                ease: 'power1.inOut',
              },
              '<',
            );

            progressContent.forEach((c, j) => {
              if (j !== i) {
                tl.to(
                  c,
                  {
                    y: `-=${steadyMovement / 2}`,
                    ease: 'none',
                  },
                  '<',
                );
              }
            });

            tl.to(
              progressPointDescriptions[prevIndex],
              {
                color: defaultColor,
                duration: 0.01,
                ease: 'power1.out',
              },
              '<',
            );
            tl.to(
              slides[prevIndex],
              {
                opacity: 0,
                duration: 0.01,
                ease: 'power1.out',
              },
              '<',
            );

            tl.to(
              progressPointDescriptions[i],
              {
                color: activeColor,
                duration: 0.01,
                ease: 'power1.out',
              },
              '<',
            );
            tl.to(
              slides[i],
              {
                opacity: 1,
                duration: 0.02,
                ease: 'power1.out',
              },
              '<',
            );
            tl.to(
              content,
              {
                y: `-=${lastPart}`,
                ease: 'none',
              },
              '<',
            );

            prevIndex = i;
          }
        });
      }
    });
  };

  return TimelineAnimation;
})();
